import { BannerMobileFormData, BannerMobileOrderItem, BannerMobileGetApiResponse, BannerMobileListApiResponse } from "../context/BannerMobileContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	ADD: "/cms/add-mobile-banner",
	UPDATE: "/cms/update-mobile-banner",
	REMOVE: "/cms/remove-mobile-banner",
	GET: "/cms/get-mobile-banner-details",
	LIST: "/cms/get-mobile-banner-list",
	ORDER: "/cms/update-mobile-banner-orders"
};

export class BannerMobileService {
	static async addBannerMobile(bannerData: BannerMobileFormData) {
		const formData = new FormData();

		formData.append("isActive", bannerData.isActive ? "true" : "false");

		formData.append("isUpper", bannerData.isUpper ? "true" : "false");

		if (bannerData.images.image) {
			formData.append("image", bannerData.images.image);
		}

		formData.append("hasNavigation", bannerData.hasNavigation ? "true" : "false");

		if (bannerData.bannerMobileLocalizable && bannerData.bannerMobileLocalizable.length > 0) {
			bannerData.bannerMobileLocalizable.forEach((item, index) => {
				if (item.url) {
					formData.append(`bannerMobileLocalizable[${index}].url`, item.url);
				}
				formData.append(`bannerMobileLocalizable[${index}].firstHeader`, item.firstHeader || "");
				formData.append(`bannerMobileLocalizable[${index}].header`, item.header || "");
				formData.append(`bannerMobileLocalizable[${index}].culture`, item.culture || "");
			});
		}

		const response = await axiosInstance.post(`${ENDPOINTS.ADD}`, formData);
		return response.data;
	}

	static async getBannerMobileList(): Promise<BannerMobileListApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.LIST}`);
		return response.data;
	}

	static async getBannerMobileDetails(id: string): Promise<BannerMobileGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?bannerId=${id}`);
		return response.data;
	}

	static async updateBannerMobile(bannerData: BannerMobileFormData) {
		const formData = new FormData();

		formData.append("bannerId", bannerData.bannerId ?? "");

		if (bannerData.isActive !== undefined) {
			formData.append("isActive", bannerData.isActive ? "true" : "false");
		}

		if (bannerData.images.image) {
			formData.append("image", bannerData.images.image);
		}

		if (bannerData.isUpper !== undefined) {
			formData.append("isUpper", bannerData.isUpper ? "true" : "false");
		}

		if (bannerData.hasNavigation !== undefined) {
			formData.append("hasNavigation", bannerData.hasNavigation ? "true" : "false");
		}

		if (bannerData.bannerMobileLocalizable && bannerData.bannerMobileLocalizable.length > 0) {
			bannerData.bannerMobileLocalizable.forEach((item, index) => {
				if (item.bannerLocalizableId?.trim()) {
					formData.append(`bannerMobileLocalizable[${index}].bannerLocalizableId`, item.bannerLocalizableId);
				}

				if (item.culture?.trim()) {
					formData.append(`bannerMobileLocalizable[${index}].culture`, item.culture);
				}

				if (item.firstHeader?.trim()) {
					formData.append(`bannerMobileLocalizable[${index}].firstHeader`, item.firstHeader);
				}

				if (item.header?.trim()) {
					formData.append(`bannerMobileLocalizable[${index}].header`, item.header);
				}

				if (item.url?.trim()) {
					formData.append(`bannerMobileLocalizable[${index}].url`, item.url);
				}
			});
		}

		const response = await axiosInstance.patch(`${ENDPOINTS.UPDATE}`, formData);
		return response.data;
	}

	static async removeBannerMobile(id: string) {
		const response = await axiosInstance.delete(`${ENDPOINTS.REMOVE}?bannerId=${id}`);
		return response.data;
	}

	static async updateBannerMobileOrders(request: {
		upperBannerMobileList: BannerMobileOrderItem[];
		lowerBannerMobileList: BannerMobileOrderItem[];
	}) {
		const formData = new FormData();

		if (request.upperBannerMobileList && request.upperBannerMobileList.length > 0) {
			request.upperBannerMobileList.forEach((item, index) => {
				formData.append(`upperBannerMobileList[${index}].bannerId`, item.bannerId || "");
				formData.append(`upperBannerMobileList[${index}].displayOrder`, item.displayOrder?.toString() || "");
			});
		}

		if (request.lowerBannerMobileList && request.lowerBannerMobileList.length > 0) {
			request.lowerBannerMobileList.forEach((item, index) => {
				formData.append(`lowerBannerMobileList[${index}].bannerId`, item.bannerId || "");
				formData.append(`lowerBannerMobileList[${index}].displayOrder`, item.displayOrder?.toString() || "");
			});
		}

		const response = await axiosInstance.put(`${ENDPOINTS.ORDER}`, formData);
		return response.data;
	}
}